// src/components/core/MigrationModal/MigrationTokenFormModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useEffect } from 'react';
import { Alert, Space, Typography } from 'antd';
import translateX from 'utils/translateX';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import SimplePassword from 'components/SimpleComponents/SimplePassword';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const MigrationTokenStepContent = () => {
  const { goFocus } = useSimpleFormContext();

  // Auto-focus the token field when step mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      goFocus?.('migrationToken', true);
    }, 150);
    return () => clearTimeout(timer);
  }, [goFocus]);

  return (
    <Space orientation="vertical" className="mt-3" style={{ width: '100%' }} size="middle">
      <Alert
        description={
          <Space orientation="vertical" size="small" style={{ width: '100%' }}>
            <Text>{translateX('migration_token_info_description')}</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {translateX('migration_token_provided_by_admin')}
            </Text>
          </Space>
        }
        type="info"
        showIcon
      />

      <SimplePassword
        name="migrationToken"
        label="enter_the_token"
        required
        autoComplete="off"
        placeholder="ex: migrace.4c46306a-6c85-41bd-a485-826ae7d939b7"
        minLength={50}
        maxLength={80}
      />
    </Space>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const migrationTokenStep = () => ({
  stepTitle: 'migration_token',
  stepTooltip: 'configure_migration_token',
  content: () => <MigrationTokenStepContent />,
  validationFields: ['migrationToken'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default migrationTokenStep;
